module.exports = __webpack_public_path__ + "media/images/icons/outlined/more-87973b4557a7f1a5b9162933b52a8335.svg";